import type { IRegexSerializer } from '../../util';
import type { IMessage } from '../interface/base';
import { IMessageHeaderAppendResponderPayload, MESSAGE_TYPE } from '../interface/headerAppend';

function construct(
    args: {
        matcher: RegExp;
        headerKey: string;
        headerVal: string;
        expiration: Date;
    },
    deps: { regexParser: IRegexSerializer },
): IMessageHeaderAppendResponderPayload {
    return {
        type: MESSAGE_TYPE,
        payload: {
            matcher: deps.regexParser.stringify(args.matcher),
            key: args.headerKey,
            val: args.headerVal,
            expiration: args.expiration.getTime(),
        },
    };
}

function isMatch(object: unknown): object is IMessageHeaderAppendResponderPayload {
    if (!object || typeof object !== 'object') {
        return false;
    }
    const record: Partial<IMessageHeaderAppendResponderPayload> =
        object as Partial<IMessageHeaderAppendResponderPayload>;

    const isNullOrUndefined = (value: unknown) => value === null || value === undefined;

    return (
        !isNullOrUndefined(record?.type) &&
        !isNullOrUndefined(record?.payload) &&
        !isNullOrUndefined(record?.payload?.matcher) &&
        !isNullOrUndefined(record?.payload?.key) &&
        !isNullOrUndefined(record?.payload?.val) &&
        !isNullOrUndefined(record?.payload?.expiration) &&
        record.type === MESSAGE_TYPE
    );
}

const controller: IMessage<
    IMessageHeaderAppendResponderPayload,
    Parameters<typeof construct>[0],
    Parameters<typeof construct>[1]
> = {
    construct,
    isMatch,
};

export default controller;
